module.exports = __webpack_public_path__ + "static/img/pc_banner1.e35e947.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pc/pc_banner1.png
// module id = UL0E
// module chunks = 1